const RESOURCE = {
  USERS: '/users',
  USER_TTS: '/user-tts',
  VOICES: '/voices',
  PACKAGES: '/packages',
  PAYMENT_METHODS: '/payment-methods',
  BANKS: '/banks',
  ORDERS: '/orders',
  LANGUAGES: '/languages',
  UPLOAD_PRESIGNED_URL: '/presigned-url-for-uploading',
  SHARING_PRESIGNED_URL: '/presigned-url-for-sharing',
  REQUESTS: '/requests',
  SYNTHESIS: '/synthesis',
  BACKGROUND_MUSICS: '/background-musics',
  DICTIONARY: '/dictionary',
  VERSION: '/version',
  VOUCHERS: '/vouchers',
  BANNERS: 'banners',
  WARNINGS: 'warnings',
  CLIENT_PAUSE: '/client-pause',
  CAPTION_TEMPLATES: '/caption-templates',
  FONTS: '/fonts',
  BLACK_WORDS: '/black-words',
  CRAWLERS: '/crawlers',
  DEVICES: '/devices',
  AFFILIATE_MARKETER: '/affiliateMarketer',
  AFFILIATE_TRANSACTION: '/affiliateTransaction',
  FILES: '/files',
  DUBBING: '/dubbing',
  FEEDBACKS: '/feedbacks',
  SRT: '/srt',
  VOICE_CLONING: '/voice-cloning',
  SAMPLE_SCRIPTS: '/sample-scripts',
  PROJECTS: '/projects',
  SPEAKERS: '/speakers',
  REFERRAL: '/referral',
  TTS_PRESET: '/tts-presets',
  FAVOURITE_VOICES: '/favourite-voices',
  APPS: '/apps',
  STATISTICS: '/stats',
  TRANSLATE: '/translate',
  REWRITE: '/rewrite',
};

const PAGINATION_LIMIT = 5;

const PAGINATION_LIMIT_REQUEST = 10;

const ZERO_BREAK_TIME_REGEX = new RegExp('<break time=0s/>');

const UPDATE_ONLINE_STATUS_INTERVAL = 5 * 60 * 1000;

const TIMER_INTERVAL = 1000;

const POPUP_TIME_OUT = 5000;

const PREDICT_SECONDS_PER_CHARACTER = 60 / 1000;

const AUTO_PLAY_INTERVAL = 7000;

const BREAK_LINE_DELIMITER = /\r?\n/;

const MAX_AUDIO_RETENTION_PERIOD = 15; // days

const SCROLL_THRESHOLD = 100;

const COUNTRY = { VN: 'VN', EN: 'EN', PH: 'PH', TH: 'TH', CN: 'CN' };

const LANGUAGE = { VN: 'vi', EN: 'en', PH: 'fil', TH: 'th', CN: 'cn' };

const VIETNAM_LOCATION = {
  city: '',
  country: 'VN',
  ip: '',
  loc: '',
  org: '',
  postal: '',
  region: '',
  timezone: 'Asia/Bangkok',
};

const HELP_CONTACT_METHOD = {
  ZALO: 'zalo',
  CALL: 'call',
};

const MOBILE_BREAKPOINT = 768;

const EVENT_TYPE = {
  STUDIO_CONVERT_TTS: 'Studio_Convert_TTS',
  STUDIO_PREVIEW_TTS: 'Studio_Preview_TTS',
  STUDIO_ACTIVE_FREE_PLAN: 'Active_FreePlan',
  BUY_PACKAGE: 'Buy_Package',
  DEVICE_MANAGER: 'Device_Manager',
  AFFILIATE_REGISTRATION: 'Affiliate_registration',
  SIGN_UP_SUCCESS: 'STUDIOStartRegistration',
  VIEW_PRICING: 'view_pricing',
  ADD_TO_CART: 'add_to_cart',
  CHECKOUT: 'check_out',
  TRY_VOICE: 'try_voice',
};

const DIALOG_V2_TYPE = {
  BLOCK_SYNTHESIS: 'block_synthesis',
  NON_VBEE_WARNING: 'non_vbee_warning',
  CANNOT_USE_VOICE: 'cannot_use_voice',
  RENAME_VOICE: 'rename_voice',
  SPAM_PREVIEW: 'spam_preview',
};

const NOTIFICATION_DIALOG_V3_TYPE = {
  CANNOT_USE_VOICE: 'cannot_use_voice',
};

const IMAGE_TYPE_FILE = ['jpg', 'jpeg', 'png', 'gif', 'svg'];

const SPECIAL_CHARACTER_REGEX = /[^a-zA-Z0-9-_]/g;
const HTML_TAG_REGEX = /<.*?>|\n/g;
const HTML_TAG_REGEX_SRT_PROJECT = /<[^>]*>/g;
const TIME_DELTA_REGEX =
  /^(?:[0-9]{2}:[0-5][0-9]:[0-5][0-9](?:[.,][0-9]{1,3})?)$/; // Eg: 00:59:59,000 or 00:59:59

const SERVICE_SELECT_TYPE = {
  STUDIO: 'STUDIO',
  API: 'API',
  DUBBING: 'DUBBING',
};

const TIME_CONVERT_THOUSANDS_CHARACTERS = 10 * 1000; // 10s

const SCREEN_TYPE = {
  MOBILE: 'MOBILE',
  WEB: 'WEB',
};

const TIME_DELAY_CALL_API_GET_USER_INFO = 3000;

const GET_TTS_USER_RETRY_FIRST_DELAY = 1000;
const GET_TTS_USER_RETRY_MAX_DELAY = 16000;

const ERROR_MESSAGE_AUTH = {
  user_already_exists: {
    message: 'user_already_exists',
    description: 'userAlreadyExists',
  },
  // TODO: Add more error message
};

const SMS_IDENTITY_PROVIDER = {
  MOBIFONE: 'mobifone',
};

const WALLET_TYPES = {
  STUDIO_CYCLE: 'studio_cycle',
  STUDIO_TOP_UP: 'studio_top_up',
  STUDIO_CUSTOM: 'studio_custom',
  STUDIO_ONE_TIME: 'studio_one_time',
};

const DAY_OF_WEEK = {
  0: 'Sunday',
  1: 'Monday',
  2: 'Tuesday',
  3: 'Wednesday',
  4: 'Thursday',
  5: 'Friday',
  6: 'Saturday',
};

const EMAIL_REGEX =
  /^[a-zA-Z0-9_]+([.][a-zA-Z0-9_]+)*[@][a-zA-Z0-9_]+([.][a-zA-Z0-9_]+)*[.][a-zA-Z]{2,4}$/;

const DEFAULT_DURATION_WAIT_COPY_BUTTON = 3000;

const CAPTCHA_PROVIDER = {
  RECAPTCHA: 'RECAPTCHA',
  TURNSTILE: 'TURNSTILE',
};

const ONBOARDING_POPUP_TYPE = {
  VOICE_CLONING: 'VOICE_CLONING',
  DUBBING: 'DUBBING',
  PROJECT: 'PROJECT',
  PREVIEW: 'PREVIEW',
  AI_PRONUNCIATION_CHECK: 'AI_PRONUNCIATION_CHECK',
  EDUCATORS: 'EDUCATORS',
};

const RELATED_UNIT_CODE_LENGTH = 7;
const RELATED_UNIT_CODE_REGEX = /^\d+$/; // Only digits

const NEW_ACTIONS_HEADER_MENU = {
  TASK_CREDIT: 'taskCredit',
  LEADERBOARD_VOICE: 'leaderboardVoice',
  GUIDE_CREDIT: 'guideCredit',
  NOTIFICATION: 'notification',
};

export {
  NEW_ACTIONS_HEADER_MENU,
  RESOURCE,
  PAGINATION_LIMIT,
  ZERO_BREAK_TIME_REGEX,
  PAGINATION_LIMIT_REQUEST,
  UPDATE_ONLINE_STATUS_INTERVAL,
  POPUP_TIME_OUT,
  PREDICT_SECONDS_PER_CHARACTER,
  TIMER_INTERVAL,
  BREAK_LINE_DELIMITER,
  MAX_AUDIO_RETENTION_PERIOD,
  SCROLL_THRESHOLD,
  COUNTRY,
  LANGUAGE,
  HELP_CONTACT_METHOD,
  AUTO_PLAY_INTERVAL,
  VIETNAM_LOCATION,
  MOBILE_BREAKPOINT,
  EVENT_TYPE,
  IMAGE_TYPE_FILE,
  SPECIAL_CHARACTER_REGEX,
  HTML_TAG_REGEX,
  TIME_DELTA_REGEX,
  SERVICE_SELECT_TYPE,
  TIME_CONVERT_THOUSANDS_CHARACTERS,
  SCREEN_TYPE,
  TIME_DELAY_CALL_API_GET_USER_INFO,
  GET_TTS_USER_RETRY_FIRST_DELAY,
  GET_TTS_USER_RETRY_MAX_DELAY,
  ERROR_MESSAGE_AUTH,
  SMS_IDENTITY_PROVIDER,
  DIALOG_V2_TYPE,
  NOTIFICATION_DIALOG_V3_TYPE,
  WALLET_TYPES,
  DAY_OF_WEEK,
  EMAIL_REGEX,
  DEFAULT_DURATION_WAIT_COPY_BUTTON,
  CAPTCHA_PROVIDER,
  ONBOARDING_POPUP_TYPE,
  RELATED_UNIT_CODE_LENGTH,
  RELATED_UNIT_CODE_REGEX,
  HTML_TAG_REGEX_SRT_PROJECT,
};
